<template>
  <div class="container">
    <div class="fixed-tabs">
      <van-tabs v-model="activeTab" sticky color="#FFDA3E" @click="handleTabClick">
        <van-tab :name="''" title="全部"></van-tab>
        <van-tab :name="0" title="未开始"></van-tab>
        <van-tab :name="1" title="进行中"></van-tab>
        <van-tab :name="2" title="已完成"></van-tab>
      </van-tabs>
      <van-search class="fixed width-99 z-99" clearable shape="round" v-model="queryData.taskName" show-action
                  @search="onSearch" placeholder="输入任务名称搜索">
        <template #action>
          <div class="w-110 h-52 l-h-52 bg-FFDA3E b-r-28 text-center" @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div>
    <!--  站位盒子  -->
    <div class="h-200"></div>
    <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
      <van-list
          v-model="pageLoading"
          :finished="pageFinished"
          finished-text=" - 没有更多了 - "
          @load="onLoad">
        <van-row class="m-t-10" align="center" v-for="item in filteredTasks" :key="item.id">
          <van-col :span="24">
            <div class="task-block">
              <van-tag class="task-state wks" size="small" v-if="item.status == 0" mark type="primary">未开始</van-tag>
              <van-tag class="task-state ywc" size="small" v-if="item.status == 2" mark type="primary">已完成</van-tag>
              <van-tag class="task-state jxz" size="small" v-if="item.status == 1" mark type="primary">进行中</van-tag>
              <van-tag class="task-state yzz" size="small" v-if="item.status == 3" mark type="primary">已中止</van-tag>
              <!--点击内容跳转详情，添加此div-->
              <div @click="viewFeedback(item)">
                <van-row type="flex" class="p-t-15" align="center" justify="center">
                  <van-col :span="3">
                    <van-icon name="card" size="30" color="#FFDA3E"/>
                  </van-col>
                  <van-col :span="19">
                    <div class="sender-info">
                      <span class="task-title">{{ item.taskName }}</span>
                    </div>
                  </van-col>
                </van-row>
                <van-row type="flex" align="center" justify="center">
                  <van-col :span="6">
                    <div class="sender-info">
                      <span class="row-name">所属项目</span>
                    </div>
                  </van-col>
                  <van-col :span="16">
                    <div class="sender-info">
                      <span class="row-value">{{ item.projectName }}</span>
                    </div>
                  </van-col>
                </van-row>
                <van-row type="flex" align="center" justify="center">
                  <van-col :span="6">
                    <div class="sender-info">
                      <span class="row-name">计划时间</span>
                    </div>
                  </van-col>
                  <van-col :span="16">
                    <div class="sender-info">
                      <span class="row-value">{{ item.planStartTime }}至{{ item.planEndTime }}</span>
                    </div>
                  </van-col>
                </van-row>
                <van-row type="flex" align="center" justify="center">
                  <van-col :span="6">
                    <div class="sender-info">
                      <span class="row-name">实际时间</span>
                    </div>
                  </van-col>
                  <van-col :span="16">
                    <div class="sender-info">
                      <span class="row-value">{{
                          item.startTime == null ? '' : item.startTime
                        }}{{ item.endTime == null ? '' : '至' + item.endTime }}</span>
                    </div>
                  </van-col>
                </van-row>
                <van-row v-if="item.status != 2" type="flex" align="center" justify="center">
                  <van-col :span="6">
                    <div class="sender-info">
                      <span class="row-name">今日是否反馈</span>
                    </div>
                  </van-col>
                  <van-col :span="16">
                    <div class="sender-info">
                      <van-tag v-if="item.feedBackToday == '已反馈'" plain type="primary">已反馈</van-tag>
                      <van-tag v-if="item.feedBackToday == '未反馈'" plain type="danger">未反馈</van-tag>
                    </div>
                  </van-col>
                </van-row>
                <van-row type="flex" align="center" justify="center">
                  <van-col :span="6">
                    <div class="sender-info">
                      <span class="row-name">任务进度</span>
                    </div>
                  </van-col>
                  <van-col :span="16">
                    <div class="sender-info">
                      <van-progress color="#FFDA3E" :percentage="item.progress" stroke-width="8"/>
                    </div>
                  </van-col>
                </van-row>
              </div>
              <van-row type="flex" align="center" justify="center">
                <van-col :span="10">
                  <div class="task-btn1">
                    <van-button @click="addFeedback(item)" class="custom-button" icon="add-o" size="small" plain
                                hairline type="primary">
                      添加反馈
                    </van-button>
                  </div>
                </van-col>
                <van-col :span="10">
                  <div class="task-btn2">
                    <van-button @click="viewFeedback(item)" class="custom-button" icon="browsing-history-o" size="small"
                                plain hairline type="info">
                      查看详情
                    </van-button>
                  </div>
                </van-col>
              </van-row>
            </div>
          </van-col>
        </van-row>
      </van-list>
    </van-pull-refresh>

    <!--反馈任务部分代码--开始-->
    <van-popup position="bottom"
               v-model="addFeedbackShow"
               lock-scroll
               round
    >
      <div class="addFeedbackDiv">
        <van-row class="feedback-title" @click="closeAddFeedback">
          <van-col :span="24">
            <van-row class="title-row">
              <van-col align="center" :span="24">
                <span class="m-r-5">任务反馈</span>
                <van-icon name="arrow-down"/>
              </van-col>
            </van-row>
          </van-col>
        </van-row>
        <van-notice-bar
            left-icon="volume-o"
            :text="`提示：当日累计反馈工时上限为 24 小时，当前已提交 ${ receivedHours }
                            小时，剩余最多可反馈 ${ 24 - Number(receivedHours) } 小时。`"
        />
        <van-row class="feedback-row" type="flex" align="center" justify="center">
          <van-col :span="6">
            <div class="sender-info">
              <span class="row-name">任务名称</span>
            </div>
          </van-col>
          <van-col :span="16">
            <div class="sender-info">
              <span class="row-value">{{ feedbackForm.taskName }}</span>
            </div>
          </van-col>
        </van-row>
        <!--是否补录-->
        <van-row class="feedback-row" type="flex" align="center" justify="center">
          <van-col :span="6">
            <div class="sender-info">
              <span class="row-name">是否补录</span>
            </div>
          </van-col>
          <van-col :span="16">
            <div class="sender-info">
                <span class="row-value">
                  <van-radio-group v-model="feedbackForm.blFlag" @change="blChange" direction="horizontal">
                    <van-radio checked-color="#FFDA3E" name="Y">是</van-radio>
                    <van-radio checked-color="#FFDA3E" name="N">否</van-radio>
                  </van-radio-group>
              </span>
            </div>
          </van-col>
        </van-row>

        <!--补录时间-->
        <van-row v-if="feedbackForm.blFlag==='Y'" class="feedback-row" type="flex" align="center" justify="center">
          <van-col :span="24">
            <van-field
                clickable
                required
                readonly
                v-model="feedbackForm.createTime"
                label="补录时间"
                placeholder="请选择补录时间"
                @click="createTimeShow = true"
            />
            <van-popup v-model="createTimeShow" position="bottom">
              <van-datetime-picker
                  v-model="feedbackForm.createDateTime"
                  type="datetime"
                  title="选择完整时间"
                  @confirm="dateTimeConfirm"
                  :max-date="maxDate"
                  @cancel="createTimeShow = false"
              />
            </van-popup>
          </van-col>
        </van-row>
        <!--完成情况-->
        <van-row class="feedback-row" type="flex" align="center" justify="center">
          <van-col :span="24">
            <van-field
                required
                v-model="feedbackForm.message"
                rows="3"
                autosize
                label="完成情况"
                type="textarea"
                maxlength="500"
                placeholder="请输入完成情况"
                show-word-limit
            />
          </van-col>
        </van-row>
        <!-- 工时 -->
        <van-row class="feedback-row" type="flex" align="center" justify="center">
          <van-col :span="24">
            <van-field required v-model="feedbackForm.hour" type="number" label="工时"
                       placeholder="请输入工时，最多支持一位小数">
              <template #right-icon>
                  <span class="row-value">
                    小时
                  </span>
              </template>
            </van-field>
          </van-col>
        </van-row>
        <!-- 任务进度 -->
        <van-row v-if="feedbackForm.executorLeader == loginUser.userId" class="feedback-row" type="flex" align="center"
                 justify="center">
          <van-col :span="6">
            <div class="sender-info">
              <span class="row-name">任务进度</span>
            </div>
          </van-col>
          <van-col :span="11">
            <div class="sender-info">
              <van-slider bar-height="6px" active-color="#FFDA3E" v-model="feedbackForm.progress"/>
            </div>
          </van-col>
          <van-col align="right" :span="5">
            <div class="sender-info">
              <van-field v-model="feedbackForm.progress" input-align="right" type="number">
                <template #right-icon>
                  <span class="row-value">
                    %
                  </span>
                </template>
              </van-field>
            </div>

          </van-col>
        </van-row>
        <!-- 附件 -->
           <van-row class="feedback-row" type="flex" align="center" justify="center">
          <van-col :span="24">
           <van-field :value.prop="feedbackForm.fileList" class="noAfterBorder fileValueBox" input-align="right" name="fj"  label="附件" placeholder="请上传文件">
          <template #input>
            <uploadFiles :files="feedbackForm.fileList" @success="uploadSuccess" moduleType="taskFeedback"
             @fileRemove="(removedFile)=>handleFileRemove(removedFile,'feedbackForm','fileList')"></uploadFiles>
          </template>
            </van-field>
          </van-col>
        </van-row>
          <!-- <van-row class="feedback-row" type="flex" align="center" justify="center">
          <van-col :span="6">
            <div class="sender-info">
              <span class="row-name">附件</span>
            </div>
          </van-col>
          <van-col :span="16">
            <div class="sender-info">
               <uploadFiles :files="feedbackForm.showFileList" @success="uploadSuccess"
             @fileRemove="(removedFile)=>handleFileRemove(removedFile,'feedbackForm','showFileList')"></uploadFiles>
            <van-uploader multiple :max-count="10" v-model="feedbackForm.showFileList" :after-read="afterAddFile"/> 
            </div>
          </van-col>
        </van-row>-->
        <!-- 提交按钮 -->
        <van-row class="feedback-row" type="flex" align="center" justify="center">
          <van-col :span="10">
            <div class="task-btn1">
              <van-button @click="closeAddFeedback" class="custom-button" icon="revoke" size="small" plain hairline
                          type="primary">
                取消
              </van-button>
            </div>
          </van-col>
          <van-col :span="10">
            <div class="task-btn2">
              <van-button @click="submitFeedback" class="custom-button" icon="certificate" size="small" plain hairline
                          type="info">
                提交
              </van-button>
            </div>
          </van-col>
        </van-row>
      </div>
    </van-popup>
    <!--反馈任务部分代码--结束-->
    <div class="zjm-fixed-bottom pos-b-20 pos-r-20 bg-FFDB43 cor-FF font-28" @click="goBack">返回</div>
  </div>
</template>
<script>
import {Cell, CellGroup, Search, Tab, Tabs, Toast} from 'vant';
import {getFeedbackHours, getMyTaskListAPI, saveFeedbackAPI} from '@/api/task.js';
import uploadFiles from "@/components/uploadFiles/index.vue";
import fileMixins from "@/components/uploadFiles/fileMixins";
export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Search.name]: Search,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    uploadFiles
  },
  mixins: [fileMixins],
  data() {
    return {
      searchValue: '',
      messageList: [],
      refreshLoading: false,
      pageLoading: false,
      pageFinished: true,
      queryData: {
        taskName: '',
        pageNum: 1, // 当前页码
        pageSize: 10 // 每页条数
      },
      loginUser: {
        userId: ''
      },
      filteredTasks: [],
      activeTab: '',
      addFeedbackShow: false,

      feedbackForm: {
        blFlag: 'N',
        progress: 0,
        createDateTime: new Date(),
        hour: '',
        fileList: [],
        showFileList: [],
      },
      createTimeShow: false,
      maxDate: new Date(),
      maxSize: 10,
      receivedHours: 0,
      isUploading: false, // 添加上传状态
      isSubmitting: false, // 添加防重复点击状态变量
    };
  },
  created() {
    setTimeout(() => {
      this.loginUser = JSON.parse(sessionStorage.getItem('userInfo'));
    }, 1000);

    this.pageFinished = false
    this.onLoad()
  },
  methods: {
    /**
     * 添加反馈
     */
    addFeedback(data) {
      this.feedbackForm.taskName = data.taskName;
      this.feedbackForm.taskId = data.taskId;
      this.feedbackForm.progress = data.progress;
      this.feedbackForm.fileList = [];
      this.feedbackForm.showFileList = [];
      this.feedbackForm.executorLeader = data.executorLeader;
      this.feedbackShow = true;
      this.addFeedbackShow = true;
      this.feedbackHours()
    },
    feedbackHours(createTime) {
      getFeedbackHours({
        createTime: createTime,

      }).then((response) => {
        this.receivedHours = response.data.hours
      })
    },
    closeAddFeedback() {
      this.addFeedbackShow = false;
    },
    /**
     * 提交反馈
     */
    submitFeedback() {
      // 防重复点击
      if (this.isSubmitting) {
        Toast.fail('正在提交中，请勿重复点击');
        return;
      }
      // 检查是否正在上传文件
      if (this.isUploading) {
        Toast.fail('文件正在上传中，请稍后保存');
        return;
      }
      if (isNaN(this.feedbackForm.hour)) {
        return Toast.fail("工时必须为数字");
      }
      if (!this.feedbackForm.hour) {
        Toast.fail("请输入工时");
        return;
      } else if (this.feedbackForm.hour < 0) {
        Toast.fail("工时不能小于0");
        return;
      } else if (this.feedbackForm.hour > 24) {
        Toast.fail("工时不能大于24");
        return;
      } else if (this.feedbackForm.hour.toString().split('.')[1] && this.feedbackForm.hour.toString().split('.')[1].length > 1) {
        Toast.fail("工时只能输入一位小数");
        return;
      }
      if (!this.feedbackForm.message) {
        Toast.fail("完成情况不能为空");
        return;
      }
      if (this.feedbackForm.hour == null) {
        Toast.fail("工时不能为空");
        return;
      }
      if (this.feedbackForm.progress == 0 && this.feedbackForm.executorLeader == this.loginUser.userId) {
        Toast.fail("任务进度不能为0");
        return;
      }
      if (this.feedbackForm.blFlag == 'Y' && this.feedbackForm.createTime == '') {
        Toast.fail("补录时间不能为空");
        return;
      }
      // 设置提交状态
      this.isSubmitting = true;
      // 添加即时反馈
      Toast.loading({
        message: '保存中...',
        forbidClick: true,
        duration: 0
      });
      // 清理和格式化数据，特别是iOS设备上的文件数据
      const submitData = this.formatSubmitData(this.feedbackForm);
      saveFeedbackAPI(submitData).then(res => {
        if (res.code == 200) {
          Toast.success('反馈成功');
          this.onRefresh();
          this.addFeedbackShow = false;
          this.feedbackForm = {
            taskId: '',
            taskName: '',
            message: '',
            progress: 0,
            hour: 8,
            blFlag: 'N',
            createTimeStr: Number(new Date()),
            createTime: '',
          };
        } else {
          Toast.fail(res.message)
        }
      })

    },
    /**
     * 格式化提交数据，清理iOS设备上的特殊数据格式
     */
    formatSubmitData(formData) {
      // 深拷贝数据，避免修改原始数据
      const data = JSON.parse(JSON.stringify(formData));

      // 清理文件列表数据，只保留必要的字段
      if (data.fileList && Array.isArray(data.fileList)) {
        data.fileList = data.fileList.map(file => ({
          id: file.id,
          fileName: file.fileName,
          filePath: file.filePath,
          createByName: file.createByName
          // 移除其他可能包含特殊iOS属性的字段
        }));
      }

      // 清理showFileList，这个字段不应该发送到后端
      delete data.showFileList;

      // 清理可能包含特殊iOS属性的字段
      delete data.visitDateTime; // 这个字段是Date对象，可能序列化有问题

      // 确保所有字符串字段都是基本类型
      const stringFields = [
        'customerCompanyName', 'customerCompanyPlace', 'visitTime',
        'visitTypeName', 'customerUserName', 'visitGoal', 'visitEntourage'
      ];

      stringFields.forEach(field => {
        if (data[field] && typeof data[field] !== 'string') {
          data[field] = String(data[field]);
        }
      });

      // 确保数字字段是数字类型
      const numberFields = ['customerCompanyId', 'customerUserId', 'visitDuration'];
      numberFields.forEach(field => {
        if (data[field] !== undefined && data[field] !== null) {
          data[field] = Number(data[field]);
        }
      });

      return data;
    },
    blChange() {
      this.feedbackForm.createTime = ''
      this.feedbackForm.createDateTime = new Date()
    },
    /**
     * 查看详情
     */
    viewFeedback(item) {
      this.$router.push({path: '/taskDetails', query: {taskId: item.taskId}})
    },
    handleTabClick(key, title) {
      this.onRefresh()
    },
    onSearch() {
      // 重置列表状态
      this.filteredTasks = [];
      this.queryData.pageNum = 1;
      this.pageFinished = true;
      // 触发加载事件，进行搜索
      this.onLoad();
    },
    onLoad(clean) {
      this.pageFinished = false
      this.pageLoading = true
      // this.loginUser.userId = JSON.parse(sessionStorage.getItem('userInfo')).userId;
      var data = {
        pageNum: this.queryData.pageNum,
        pageSize: this.queryData.pageSize,
        status: this.activeTab,
        taskName: this.queryData.taskName,
      };
      if (clean) {
        this.filteredTasks = []
      }
      getMyTaskListAPI(data).then(res => {

        if (res.code == 200) {
          if (this.filteredTasks.length < res.total) {
            this.filteredTasks = this.filteredTasks.concat(res.rows); // 将新数据添加到数组中
            this.queryData.pageNum++; // 增加页码
          } else {
            this.pageFinished = true; // 如果没有更多数据，则设置 finished 为 true
          }
          this.pageLoading = false; // 加载状态结束
          this.refreshLoading = false
        }
      }).catch((err) => {
        console.error(err);
        this.pageLoading = false; // 加载状态结束
        this.refreshLoading = false
      })
    },
    onRefresh() {
      // 重置列表状态
      // this.filteredTasks = [];
      this.queryData.pageNum = 1;
      let clean = true;
      this.onLoad(clean)
    },
    /**
     *  确认补录时间
     */
    dateTimeConfirm(data) {
      this.feedbackForm.createTime = this.formatDate(data, 'yyyy-MM-dd hh:mm:ss');
      this.feedbackHours(this.formatDate(data, 'yyyy-MM-dd hh:mm:ss'))
      this.createTimeShow = false;
    },
    goBack() {
      if (this.$route.query.lastPage) {
        this.$router.push({
          path: this.$route.query.lastPage,
          query: {
            tabIndex: this.$route.query.lastPageTabIndex
          }
        })
      } else {
        this.$router.go(-1)
      }
    },
    formatDate(date, fmt) {
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      }
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + ''
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str))
        }
      }
      return fmt
    },
    padLeftZero(str) {
      return ('00' + str).substr(str.length)
    },
    uploadSuccess(fileList) { // 每次都会filelist全部丢出来
      this.feedbackForm.fileList = fileList
    },
    // // 上传附件到后台
    // afterAddFile(file) {
    //   // 处理多文件上传的情况
    //   if (Array.isArray(file)) {
    //     file.forEach(item => this.handleSingleFile(item));
    //     return;
    //   }
    //   this.handleSingleFile(file);
    // },
    // // 处理单个文件上传
    // handleSingleFile(file) {
    //   // 检查文件大小
    //   if (file.size / 1024 / 1024 > this.maxSize) {
    //     Toast.fail(`单个附件最大不超过 ${this.maxSize}MB`);
    //     return false;
    //   }

    //   // 设置上传状态
    //   this.isUploading = true;
    //   Toast.loading({
    //     message: '上传中...',
    //     forbidClick: true,
    //     duration: 0
    //   });

    //   let FormDatas = new FormData();
    //   FormDatas.append('file', file.file);
    //   FormDatas.append('moduleType', 'visit');

    //   upLoadFile(FormDatas).then(res => {
    //     // 重置上传状态
    //     this.isUploading = false;
    //     Toast.clear();

    //     if (res.data && res.code === 200) {
    //       res.data.fileName = file.file.name
    //       res.data.createByName = this.loginUser.nickName

    //       // 添加到文件列表
    //       this.feedbackForm.fileList.push(res.data);

    //       // 更新显示列表中的对应文件状态
    //       // 使用文件名作为唯一标识来查找对应的文件
    //       const fileIndex = this.feedbackForm.showFileList.findIndex(f =>
    //           f.file && f.file.name === file.file.name
    //       );

    //       if (fileIndex !== -1) {
    //         // 使用 Vue.set 或 this.$set 确保响应式更新
    //         this.$set(this.feedbackForm.showFileList, fileIndex, {
    //           ...this.feedbackForm.showFileList[fileIndex],
    //           status: 'done',
    //           message: '上传成功',
    //           fileId: res.data.id,
    //           url: this.getFileUrl(res.data.filePath) // 添加文件URL用于显示
    //         });

    //         // 强制触发视图更新
    //         this.$forceUpdate();
    //       }

    //       Toast.success('上传成功');
    //       return true;
    //     } else {
    //       Toast.fail('上传失败');
    //       return false;
    //     }
    //   }).catch(err => {
    //     // 重置上传状态
    //     this.isUploading = false;
    //     Toast.clear();
    //     console.log("上传失败", err)
    //     Toast.fail("上传失败")
    //     return false;
    //   });
    // },
    // /**
    //  * 获取文件完整URL
    //  */
    // getFileUrl(filePath) {
    //   if (!filePath) return '';

    //   // 如果已经是完整URL，直接返回
    //   if (filePath.startsWith('http://') || filePath.startsWith('https://')) {
    //     return filePath;
    //   }

    //   // 使用Vuex中的基础URL配置
    //   const baseUrl = this.$store.state.settings.image_base_url || '';

    //   // 确保路径格式正确
    //   let formattedPath = filePath;
    //   if (filePath.startsWith('/')) {
    //     formattedPath = filePath.substring(1);
    //   }

    //   return baseUrl + formattedPath;
    // },
  }
};
</script>
<style scoped>
.container {
  position: relative; /* 为 fixed 按钮提供相对定位的参照物 */
  height: 100vh; /* 或者你需要的高度 */
}

.sender-info {
  flex: 1;
}

.task-title {
  font-size: 30px;
  font-weight: 550;
  display: inline-block;
  /* line-height: 150%; */
  width: 530px; /* 17个字 * 5像素 */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.content {
  font-size: 28px;
  color: #323233;
}

.row-name {
  font-size: 28px;
  color: #969799;
}

.row-value {
  text-align: left;
  font-size: 28px;
  display: inline-block;
  line-height: 150%;
}

.fixed-tabs {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 100; /* 确保tabs在内容之上 */
}

.task-block {
  margin: 4px 8px 0px 8px;
  border-radius: 20px;
  background-color: rgb(255, 255, 255);
  display: block;
}

.task-btn1 {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  height: 100px; /* 根据需要设置高度 */
  border-top: 2px solid #d2d4d6;
}

.task-btn2 {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  height: 100px; /* 根据需要设置高度 */
  border-left: 1px solid #d2d4d6;
  border-top: 2px solid #d2d4d6;
  border-left-style: dashed;
}

.custom-button {
  width: 60%; /* 按钮宽度填充容器 */
  height: 55px; /* 按钮高度 */
  font-size: 24px; /* 按钮文字大小 */
  color: rgb(10, 80, 3);
  font-weight: 550;
}

.task-state {
  margin-left: 85%;
  position: absolute; /* 绝对定位 */
  padding-top: 1%;
}

.wks {
  background-color: rgba(77, 75, 75, 0.3);
}

.ywc {
  background-color: rgba(134, 99, 3, 0.5);
}

.jxz {
  background-color: rgba(131, 189, 6, 0.5);
}

.yzz {
  background-color: rgba(255, 70, 52, 0.5);
}

.addFeedbackDiv {
  padding: 12px 3px 5px 3px;
  background-color: rgba(225, 218, 62, 1);
  /* height:100%; */
}

.feedback-title {
  font-size: 35px;
  font-weight: 550;
  background-color: rgba(225, 218, 62, 1);
}

.title-row {
  margin: 15px
}

.feedback-row {
  /* padding:5px; */
  background-color: rgb(255, 255, 255);
}
</style>
